'use strict';

class DevicesTotalPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    var initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getTotalDevices(startDate, endDate)
        .then((reportInfo) => {

          if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
            return [];
          }

          let data = reportInfo.executions
            .slice()
            .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
            .map(execution => ({
              x: execution.executionDateMs,
              y: execution.data?.find((d) => d.id === 1)?.value
            }));

          if (initial) {
            getLastMeasurement(data[data.length - 1]);
            initial = false;
          }

          return [
            {
              data: data,
              label: $t('dash.panel.reports.devicesTotal.dashboardTitle')
            }
          ];
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(data) {
      if (!data) {
        return;
      }

      let info = [];
      for (let [key, value] of Object.entries(data)) {
        let timestamp = key === 'x';
        info.push({
          icon: timestamp ? 'clock' : 'chart-line',
          name: timestamp ? $t('dash.panel.reports.lastMeasured') : $t('dash.panel.reports.lastTotal'),
          value: timestamp ? $filter('date')(value, currentDateFormat) : value,
        });
      }
      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.devicesTotalPage.controller', [])
  .controller('DevicesTotalPageController', DevicesTotalPageController)
  .name;
